import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import resourceNotFoundImg from "../../../../../assets/img/resourceNotFound.png";
import pizzarronImg from "../../../../../assets/img/fondosTexto/pizarron.png";
import pizzarronTop from "../../../../../assets/img/fondosTexto/pizarronTop.png";
import pizzarronBottom from "../../../../../assets/img/fondosTexto/pizarronBottom.png";
import papelRayadoImg from "../../../../../assets/img/fondosTexto/cuadroRayado.png";
import papelRayadoTop from "../../../../../assets/img/fondosTexto/cuadroRayadoTop.png";
import papelRayadoBottom from "../../../../../assets/img/fondosTexto/cuadroRayadoBottom.png";
import cuadroChicoImg from "../../../../../assets/img/fondosTexto/cuadroChico.png";
import cuadroChicoTop from "../../../../../assets/img/fondosTexto/CuadroChicoTop.png";
import papelImg from "../../../../../assets/img/fondosTexto/papel.png";
import cuadroAzul from "../../../../../assets/img/fondosTexto/cuadrosAzules.png";
import tijerasImg from "../../../../../assets/img/fondosTexto/tijeras.png";
import tijerasTop from "../../../../../assets/img/fondosTexto/tijerasTop.png";
import tijerasBottom from "../../../../../assets/img/fondosTexto/tijerasBottom.png";
import coloresImg from "../../../../../assets/img/fondosTexto/colores.png";
import coloresTop from "../../../../../assets/img/fondosTexto/coloresTop.png";
import coloresBottom from "../../../../../assets/img/fondosTexto/coloresBottom.png";
import espaniolImg from "../../../../../assets/img/fondosTexto/espaniol.png";
import espaniolTop from "../../../../../assets/img/fondosTexto/espaniolTop.png";
import espaniolBottom from "../../../../../assets/img/fondosTexto/espaniolBottom.png";
import cienciasImg from "../../../../../assets/img/fondosTexto/ciencias.png";
import cienciasTop from "../../../../../assets/img/fondosTexto/cienciasTop.png";
import cienciasBottom from "../../../../../assets/img/fondosTexto/cienciasBottom.png";
import matematicasImg from "../../../../../assets/img/fondosTexto/matematicas.png";
import matematicasTop from "../../../../../assets/img/fondosTexto/matematicasTop.png";
import matematicasBottom from "../../../../../assets/img/fondosTexto/matematicasBottom.png";
import { v4 as uuidv4 } from "uuid";

//reordenar arreglos
export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

//para estilos de modal
export const customStyles = {
  content: {
    width: "100%",
    maxWidth: "1200px",
    maxHeight: "90vh",
    borderRadius: ".5rem",
    padding: "3.5rem 2rem 1rem 2rem",
    margin: "0 auto",
    height: "fit-content",
    zIndex: "+99",
    position: "relative",
    top: 80,
  },
};

//verifica si un item es par o impar dentro de un array
export function isEven(n) {
  return n % 2 == 0;
}

export function isOdd(n) {
  return Math.abs(n % 2) == 1;
}

//valida extenciones

function getExtension(filename) {
  var parts = filename.split(".");
  return parts[parts.length - 1];
}

export function isImage(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "png":
    case "svg":
      //etc
      return true;
  }
  return false;
}

export function isVideo(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case "m4v":
    case "avi":
    case "mpg":
    case "mp4":
      // etc
      return true;
  }
  return false;
}

export const colors = [
  "#3f297e",
  "#175fa9",
  "#169ed8",
  "#239b63",
  "#64b031",
  "#bfbd2e",
  "#f7a416",
  "#e6471d",
  "#dc0936",
  "#e5177b",
  "#be1180",
  "#871f7f",
  "#3f297e",
  "#175fa9",
  "#169ed8",
  "#239b63",
  "#64b031",
  "#dad842",
  "#f7a416",
  "#e6471d",
  "#dc0936",
  "#e5177b",
  "#be1180",
  "#871f7f",
];

export const useDraggableInPortal = () => {
  const self = useRef({}).current;

  useEffect(() => {
    const div = document.createElement("div");
    div.style.position = "absolute";
    div.style.pointerEvents = "none";
    div.style.top = "0";
    div.style.width = "100%";
    div.style.height = "100%";
    self.elt = div;
    document.body.appendChild(div);
    return () => {
      document.body.removeChild(div);
    };
  }, [self]);

  return (render) =>
    (provided, ...args) => {
      const element = render(provided, ...args);
      if (provided.draggableProps.style.position === "fixed") {
        return createPortal(element, self.elt);
      }
      return element;
    };
};

export const repeatedColors = Array(10).fill(colors).flat();

export const ComponentWithDimensions = (props) => {
  const targetRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight,
      });
    }
  }, []);

  return (
    <div ref={targetRef}>
      <p>{dimensions.width}</p>
      <p>{dimensions.height}</p>
    </div>
  );
};

//regresa texto sin acentos ni signos de puntuacion
export const toCleanText = (str) => {
  const acentos = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
  };
  const textoSinAcentos = str
    .split("")
    .map((letra) => acentos[letra] || letra)
    .join("")
    .toString();
  return textoSinAcentos
    .toLocaleLowerCase()
    .replace(/[.,\/#¡!¿?$%\^&\*;:{}=\-_`~()]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

//regresa texto sin espacios inecesarios
export const textWithoutSpaces = (str) => {
  return str.replace(/\s+/g, " ").trim();
};

//Revisa si un array de numeros es acendente
export function isAscending(arr) {
  return arr.every(function (x, i) {
    return i === 0 || x >= arr[i - 1];
  });
}

export const getExpTitle = (type, lang) => {
  if (type === "PALABRAS" && lang === "es") {
    return "Lectura de palabras";
  } else if (type === "PARRAFO" && lang === "es") {
    return "Lectura de párrafo (pronunciación)";
  } else if (type === "VELOCIDAD" && lang === "es") {
    return "Lectura de párrafo (velocidad)";
  }
  if (type === "PALABRAS" && lang === "en") {
    return "Word reading";
  } else if (type === "PARRAFO" && lang === "en") {
    return "Paragraph reading (pronunciation)";
  } else if (type === "VELOCIDAD" && lang === "en") {
    return "Paragraph reading (speed)";
  }
};

export const getExpDesc = (type, lang) => {
  if (type === "PALABRAS" && lang === "es") {
    return "Prepara tu micrófono, selecciona la palabra u oración, pronúnciala y para la grabación. Espera a verificar si la pronunciaste correctamente o no. Intenta con todas las palabras.";
  } else if (type === "PARRAFO" && lang === "es") {
    return "Prepara tu micrófono, pulsa el botón iniciar y lee el texto en voz alta, el sistema calificará tu pronunciación, no la rapidez con que lo hagas. Una vez que termines de dictar, pulsa el botón verificar.";
  } else if (type === "VELOCIDAD" && lang === "es") {
    return "Prepara tu micrófono,  pulsa el botón iniciar y lee el texto en voz alta lo más rápido que puedas, el sistema te irá calificando cada palabra. Si te atoras en una palabra intenta pronunciarla hasta que logres pasar, entre más rápido lo hagas mejor será tu promedio de velocidad de lectura.";
  }
  if (type === "PALABRAS" && lang === "en") {
    return "Get your microphone ready, select the word or sentence, pronounce it and stop the recording. Wait to check if you pronounced it correctly or not. Try this whith all the words.";
  } else if (type === "PARRAFO" && lang === "en") {
    return "Get your microphone ready, press the start button and read the text aloud, the system will rate your pronunciation, not how fast you do it. Once you have finished dictating, click the check button.";
  } else if (type === "VELOCIDAD" && lang === "en") {
    return "Get your microphone ready, press the start button and read the text aloud as fast as you can, the system will rate each word for you. If you get stuck on a word, try to pronounce it until you pass it, the faster you do it, the better your average reading speed will be.";
  }
};

//parse datos para relacionar columnas

export const filaUnoItems = (columnas) => {
  return columnas
    .filter((item, index) => isEven(index))
    .map((el, i) => ({ ...el, orden: i }));
};

export const filaDosItems = (columnas) => {
  return columnas
    .filter((item, index) => isOdd(index))
    .map((el, i) => ({ ...el, orden: i }));
};

export const getNuevasPreguntas = (preguntas, respuestas) => {
  const nuevasPreguntas = preguntas
    .map((el) => {
      const respuestasObj = respuestas.filter((item) =>
        el.respuestas.includes(item._id)
      );
      return { ...el, respuestas: respuestasObj };
    })
    .map((el) => ({ ...el, respuestas: shuffle(el.respuestas) }));
  return shuffle(nuevasPreguntas);
};

//agrega datos faltantes a enlaces que empiezan con www y añade un tag tipo alt a imágenes
export const replaceTextLinks = (text) => {
  return text
    ?.replaceAll(
      '<a href="www',
      '<a target="_blank" rel="noopener noreferrer" href="https://www'
    )
    .replaceAll(
      "<img ",
      `<img alt="Recurso no encontrado / Resource not found" onerror="this.src='${resourceNotFoundImg}';"`
    )
    .replaceAll("<img>", "")
    .replaceAll('disabled="disabled"', "");
};

export const folderColors = [
  "azul",
  "ladrillo",
  "cardenal",
  "fresas",
  "naranja",
  "taxi",
  "menta",
  "helecho",
  "esparrago",
  "limon",
  "arena",
  "macarrones",
  "espuma",
  "piscina",
  "vaquero",
  "cielo",
  "terciopelo",
  "dinosaurio",
  "raton",
  "montana",
  "lombriz",
  "chicle",
  "lluvia",
  "berenjena",
];

export function fileExists(image_url) {
  var http = new XMLHttpRequest();
  try {
    http.open("HEAD", image_url, false);
    http.send();
  } catch (error) {
    // Una petición síncrona puede lanzar (en vez de fallar con status) por
    // errores de red/CORS, p.ej. al renderizar muchas actividades seguidas
    // durante la generación masiva de PDFs en un iframe oculto.
    return false;
  }
  return http.status != 404;
}

export const formatearFecha = (fecha) => {
  if (!fecha) return "";
  const fechaNueva = new Date(fecha);
  return fechaNueva.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

export const roundTwoDecimals = (num) => {
  if (!num) return "";
  return (Math.round(num * 100) / 100).toFixed(2);
};

export const getRubricas = (evidenciaObj) => {
  if (evidenciaObj?.rubricasStr && evidenciaObj?.rubricasStr !== "[]")
    return JSON.parse(evidenciaObj?.rubricasStr);
  else if (evidenciaObj.rubricas) return evidenciaObj.rubricas;
  else return [];
};

export const extractAccents = (arr) => {
  const accentedChars = [];
  const accents = ["á", "é", "í", "ó", "ú", "Á", "É", "Í", "Ó", "Ú"];

  arr.forEach((word) => {
    for (let char of word) {
      if (accents.includes(char) && !accentedChars.includes(char)) {
        accentedChars.push(char);
      }
    }
  });

  return accentedChars;
};

export const handleResetConstructorActivity = (
  constructorContent,
  setConstructorContent
) => {
  const newContent = constructorContent.map((el) => {
    delete el.imagen;
    delete el.audio;
    delete el.video;
    return el;
  });
  setConstructorContent(newContent);
};

export const resetEvenItems = (constructorContent, setConstructorContent) => {
  const newContent = constructorContent.map((el, i) => {
    if (isEven(i)) {
      delete el.imagen;
      delete el.audio;
      delete el.video;
      delete el.texto;
    }
    return el;
  });
  setConstructorContent(newContent);
};

export const resetOddItems = (constructorContent, setConstructorContent) => {
  const newContent = constructorContent.map((el, i) => {
    if (isOdd(i)) {
      delete el.imagen;
      delete el.audio;
      delete el.video;
      delete el.texto;
    }
    return el;
  });
  setConstructorContent(newContent);
};

export const resetResources = (constructorContent, setConstructorContent) => {
  const newContent = constructorContent.map((el) => {
    delete el.imagen;
    delete el.audio;
    delete el.video;
    return el;
  });
  setConstructorContent(newContent);
};

export const customResourceReset = (
  constructorContent,
  setConstructorContent,
  resourcesObj
) => {
  const newContent = constructorContent.map((el) => {
    if (!resourcesObj?.hasTexto) delete el.texto;
    if (!resourcesObj?.hasAudio) delete el.audio;
    if (!resourcesObj?.hasVideo) delete el.video;
    if (!resourcesObj?.hasImagen) delete el.imagen;

    return el;
  });
  setConstructorContent(newContent);
};

export function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}
const reorderByLevel = (arr) => {
  return arr
    .map((el) => {
      if (el.uma) {
        return el;
      } else if (el.hijos) {
        return el.hijos.sort((a, b) => (a.orden > b.orden ? 1 : -1));
      } else return null;
    })
    .filter((el) => el)
    .flat();
};

export const orderContents = (contentsArr) => {
  return reorderByLevel(reorderByLevel(reorderByLevel(contentsArr)));
};

export const showHuecoWord = (string) => {
  if (string.includes("/JOIN_WORD/"))
    return string.replaceAll("/JOIN_WORD/", " ");
  else return string;
};

export const returnSortedBlocks = (blocksArray, orderArray) => {
  //nuevo orden
  if (orderArray && orderArray.length > 0) {
    return blocksArray
      .map((bloque) => {
        return {
          ...bloque,
          orden: orderArray.findIndex((id) => id === bloque._id),
          ordenReal: orderArray.findIndex((id) => id === bloque._id),
        };
      })
      .sort((a, b) => (a.orden > b.orden ? 1 : -1));
  }
  //viejo orden
  else {
    return blocksArray.sort((a, b) => (a.orden > b.orden ? 1 : -1));
  }
};

const gradients = [
  {
    name: "Gunmetal",
    class: "bg-gradient-to-b from-nimbus to-blue-800",
    isActive: false,
  },
  {
    name: "Iceberg",
    class: "bg-gradient-to-b from-blue-500 to-cyan-400",
    isActive: false,
  },
  {
    name: "Cool Water",
    class: "bg-gradient-to-b from-blue-400 to-purple-400",
    isActive: false,
  },
  {
    name: "Sunset",
    class: "bg-gradient-to-b from-red-500 to-orange-400",
    isActive: false,
  },
  {
    name: "Dusk",
    class: "bg-gradient-to-b from-purple-500 to-pink-500",
    isActive: false,
  },
  {
    name: "Sunrise",
    class: "bg-gradient-to-b from-pink-500 to-red-400",
    isActive: false,
  },
  {
    name: "Tropical Rainforest",
    class: "bg-gradient-to-b from-green-400 to-teal-400",
    isActive: false,
  },
  {
    name: "Silver Dawn",
    class: "bg-gradient-to-b from-yellow-200 via-amber-400 to-orange-600",
    isActive: false,
  },
  {
    name: "Zinc Amber",
    class: "bg-gradient-to-b from-zinc-500 via-stone-600 to-zinc-900",
    isActive: false,
  },
  {
    name: "primaria_blue",
    class: "bg-gradient-to-b from-[#003277] to-[#3688ce]",
    isActive: true,
  },
  {
    name: "primaria_red",
    class: "bg-gradient-to-b from-[#920000] to-[#e01428]",
    isActive: true,
  },
  {
    name: "primaria_green",
    class: "bg-gradient-to-b from-[#006e67] to-[#07aa8f]",
    isActive: true,
  },
  {
    name: "primaria_orange",
    class: "bg-gradient-to-b from-[#c83c00] to-[#e87b0f]",
    isActive: true,
  },
  {
    name: "primaria_ purple",
    class: "bg-gradient-to-b from-[#360050] to-[#74269e]",
    isActive: true,
  },
  {
    name: "primaria_yellow",
    class: "bg-gradient-to-b from-[#dc8200] to-[#ffca00]",
    isActive: true,
  },
];

export default gradients;

// Fondos predefinidos heredados. Ya no son seleccionables desde el modal
// "Selecciona el fondo para tu texto": se conservan únicamente para que el
// contenido que ya los referencia por nombre se siga renderizando igual.
// Los fondos que sí pueden elegirse son los creados en el Editor de fondos de
// texto (ver `selectableTextBackgroundsOptions` y TextBackgroundOptions).
export const textBackgroundsOptions = [
  /*   {
    name: "leaf",
    path: "https://cdn.pixabay.com/photo/2021/11/17/19/14/background-6804433_1280.jpg",
  }, */
  {
    name: "pizzarrón",
    path: pizzarronImg,
    header: pizzarronTop,
    footer: pizzarronBottom,
  },
  {
    name: "cuadro rayado",
    path: papelRayadoImg,
    header: papelRayadoTop,
    footer: papelRayadoBottom,
  },
  {
    name: "cuadro chico",
    path: cuadroChicoImg,
    header: cuadroChicoTop,
  },
  {
    name: "papel",
    path: papelImg,
  },
  {
    name: "cuadro azul",
    path: cuadroAzul,
  },
  {
    name: "tijeras",
    path: tijerasImg,
    header: tijerasTop,
    footer: tijerasBottom,
  },
  {
    name: "colores",
    path: coloresImg,
    header: coloresTop,
    footer: coloresBottom,
  },
  {
    name: "espaniol",
    label: "Español",
    path: espaniolImg,
    header: espaniolTop,
    footer: espaniolBottom,
  },
  {
    name: "ciencias",
    path: cienciasImg,
    header: cienciasTop,
    footer: cienciasBottom,
  },
  {
    name: "matematicas",
    label: "Matemáticas",
    path: matematicasImg,
    header: matematicasTop,
    footer: matematicasBottom,
  } /* ,
  {
    name: "lemon",
    path: "https://cdn.pixabay.com/photo/2021/10/15/11/06/lemon-background-6712130_1280.png",
  },
  {
    name: "wood",
    path: "https://img.freepik.com/free-vector/wood-vector-texture-template-pattern-seamless-material-hardwood-floor-natural-light-parquet-vector-illustration_1284-47074.jpg?t=st=1739241277~exp=1739244877~hmac=338b153779cfc9d51e927c2bca5431ca324519a2c5cfd376653a61eb4886b8a3&w=740",
  },
  {
    name: "paper",
    path: "http://img.freepik.com/free-vector/abstract-horizontal-grid-lines-graph-style-graphic-design_1017-39918.jpg",
    header:
      "https://i.ibb.co/j9R07SDn/Screenshot-2025-02-20-at-11-29-15-a-m.png",
    footer: "",
  },
  {
    name: "green board",
    path: "https://wallpaperbat.com/img/807670-chalkboard-background-free-download.jpg",
    header: "",
    footer:
      "https://i.ibb.co/XfHW6Vx9/Screenshot-2025-02-20-at-11-47-01-a-m.png",
    textColor: "#ffffff",
  }, */
];

// Fondos predefinidos que se ofrecen en el selector de fondos del editor.
// Está vacío a propósito: solo quedan "Sin fondo" y los fondos de la editorial.
// Si algún día se quiere volver a ofrecer uno de los heredados, basta con
// agregarlo aquí desde `textBackgroundsOptions`.
export const selectableTextBackgroundsOptions = [];

export const findTextBackground = (background) =>
  textBackgroundsOptions?.find((el) => el.name === background) || null;

// El bloque de texto admite dos tipos de fondo: una imagen (cenefas y fondos de
// editorial, que traen su propio padding de 5rem) o un color, que se guarda como
// clase de Tailwind (p.ej. "!bg-[#ececec]"). Con color el texto quedaba pegado a
// las orillas, así que se le deja un respiro.
export const PADDING_COLOR_FONDO_TEXTO = "30px";

export const getPaddingFondoTexto = (background, imagenDeFondo) => {
  if (imagenDeFondo) return "5rem";
  return background ? PADDING_COLOR_FONDO_TEXTO : 0;
};

export const getBackgroundStyles = (background) => {
  const foundBackground = textBackgroundsOptions?.find(
    (el) => el.name === background
  );
  return {
    backgroundImage: foundBackground
      ? `url(${foundBackground?.path})`
      : undefined,
    backgroundSize: foundBackground ? "100%" : "cover",
    backgroundPosition: "center",
    padding: foundBackground ? "5rem" : 0,
  };
};

export const lightButtonStyles =
  "m-5 py-3 px-10 rounded-full inline bg-[#f5f5f5] text-nimbusLight font-bold";

export function removeDecimals(num) {
  const number = Number(num) / 10;
  return number.toFixed(2);
}

export function removeDecimals10(num) {
  const number = Number(num);
  return number.toFixed(2);
}

export function formatToYYYYMMDD(fechaStr) {
  const meses = {
    enero: "01",
    febrero: "02",
    marzo: "03",
    abril: "04",
    mayo: "05",
    junio: "06",
    julio: "07",
    agosto: "08",
    septiembre: "09",
    octubre: "10",
    noviembre: "11",
    diciembre: "12",
  };

  const partes = fechaStr.toLowerCase().split(" de ");
  const dia = partes[0].padStart(2, "0");
  const mes = meses[partes[1]];
  const anio = partes[2];
  return `${anio}-${mes}-${dia}`;
}

export const fillBasicForm = (itemsNumber) => {
  const arr = Array.from({ length: itemsNumber }, (_, i) => ({
    _id: uuidv4(),
    orden: i,
    texto: "",
  }));
  return arr;
};

export const fillDoubleForm = (itemsNumber) => {
  const arr = Array.from({ length: itemsNumber * 2 }, (_, i) => ({
    _id: uuidv4(),
  }));
  return arr;
};

export function hasDuplicateProperty(arr, prop) {
  const seen = new Set();
  for (const item of arr) {
    const value = item[prop];
    if (seen.has(value)) {
      return true;
    }
    seen.add(value);
  }
  return false;
}

export const showSidebarBlocks = (index, setOption, setSelected) => {
  setSelected(index);
  setOption(0);
};

export const TABLE_STYLES = {
  nimbus: {
    container:
      "min-w-full rounded-xl shadow-xl ring-1 ring-black/5 overflow-hidden border-b-2 border-nimbus bg-white",
    table: "min-w-full table-auto border-nimbus ",
    thead: "bg-[#162e5b] text-white bg-nimbus",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider",
    tbody: "divide-y divide-gray-100",
    tr: "transition-colors border",
    rowLabelTd:
      "px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap border-[#dcdcdc] border bg-white",
    bodyTd:
      "px-6 py-4 text-sm text-gray-700 align-top border-[#dcdcdc] border bg-white",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-blue-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-blue-500/70 group-hover:text-blue-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell: "text-blue-600 hover:underline inline-flex items-center gap-1",
  },
  light: {
    container:
      "min-w-full rounded-xl bg-white shadow-xl ring-1 ring-black/5 overflow-hidden",
    table: "min-w-full table-auto",
    thead: "bg-white text-black",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider border",
    tbody: "divide-y divide-gray-100",
    tr: "transition-colors",
    rowLabelTd:
      "px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap border border-gray-200 bg-white",
    bodyTd:
      "px-6 py-4 text-sm text-gray-700 align-top border border-gray-200 bg-white",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-indigo-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-indigo-500/70 group-hover:text-indigo-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell:
      "text-indigo-600 hover:underline inline-flex items-center gap-1",
  },
  emerald: {
    container:
      "min-w-full rounded-xl bg-white shadow ring-1 ring-black/5 overflow-hidden border-b-2 border-emerald-600",
    table: "min-w-full table-auto ",
    thead: "bg-emerald-600 text-white rounded-t-xl",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider",
    tbody: "divide-y divide-gray-100",
    tr: "odd:bg-white even:bg-gray-50 hover:bg-emerald-50/40 transition-colors",
    rowLabelTd:
      "px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap border border-gray-100 bg-white",
    bodyTd:
      "px-6 py-4 text-sm text-gray-700 align-top border border-gray-100 bg-white",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-emerald-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-emerald-500/70 group-hover:text-emerald-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell:
      "text-emerald-600 hover:underline inline-flex items-center gap-1",
  },
  zebra: {
    container:
      "min-w-full rounded-xl bg-white shadow ring-1 ring-black/5 overflow-hidden border-b-2 border-[#317a81]",
    table: "min-w-full table-auto",
    thead: "bg-[#317a81] text-white",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider",
    tbody: "",
    tr: "odd:bg-white even:bg-[#edf7f7]",
    rowLabelTd:
      "px-6 py-3 text-sm font-semibold text-[#317a81] whitespace-nowrap border-0",
    bodyTd: "px-6 py-3 text-sm text-[#317a81] align-top border-0",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-blue-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-blue-500/70 group-hover:text-blue-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell: "text-blue-600 hover:underline inline-flex items-center gap-1",
  },
  sky: {
    container:
      "min-w-full rounded-xl bg-white shadow ring-1 ring-black/5 overflow-hidden border-b-2 border-sky-600",
    table: "min-w-full table-auto",
    thead: "bg-sky-600 text-white",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider",
    tbody: "divide-y divide-gray-100",
    tr: "odd:bg-white even:bg-gray-50 hover:bg-sky-50/40 transition-colors",
    rowLabelTd:
      "px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap border border-gray-100 bg-white",
    bodyTd:
      "px-6 py-4 text-sm text-gray-700 align-top border border-gray-100 bg-white",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-sky-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-sky-500/70 group-hover:text-sky-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell: "text-sky-600 hover:underline inline-flex items-center gap-1",
  },
  rose: {
    container:
      "min-w-full rounded-xl bg-white shadow ring-1 ring-black/5 overflow-hidden border-b-2 border-rose-600",
    table: "min-w-full table-auto",
    thead: "bg-rose-600 text-white",
    th: "px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider",
    tbody: "divide-y divide-gray-100",
    tr: "odd:bg-white even:bg-gray-50 hover:bg-rose-50/40 transition-colors",
    rowLabelTd:
      "px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap border border-gray-100 bg-white",
    bodyTd:
      "px-6 py-4 text-sm text-gray-700 align-top border border-gray-100 bg-white",
    headerEditableText: "text-white hover:underline",
    cellEditableText: "text-rose-600 hover:underline",
    iconHeader: "text-white/80 group-hover:text-white",
    iconCell: "text-rose-500/70 group-hover:text-rose-600",
    buttonHeader:
      "text-white/90 hover:text-white hover:underline inline-flex items-center gap-1",
    buttonCell: "text-rose-600 hover:underline inline-flex items-center gap-1",
  },
};

export const getContenedoresCompletos = (
  tipoActividad,
  inputList,
  respuestas
) => {
  if (tipoActividad !== "tabla") return;
  return inputList.map((el) => {
    const base = Array.isArray(el?.respuestas) ? el.respuestas : [];
    const objs = base
      .map((x) =>
        typeof x === "string" ? respuestas.find((o) => o._id === x) : x
      )
      .filter(Boolean); // drop unresolved IDs
    return {
      ...el,
      respuestas: objs.map((v) => ({ ...v, parentId: el._id })),
    };
  });
};
